import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getGateGroup } from '../../services/gateGroupService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import GateGroupGatesTab from './tab-pages/GateGroupGatesTab';
import GateGroupScopeTab from './tab-pages/GateGroupScopeTab';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function GateGroupDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [group, setGroup] = useState(null);
  const [activeTab, setActiveTab] = useState('gates');

  useEffect(() => {
    getGateGroup(id)
      .then((res) => setGroup(res.data?.data))
      .catch(() => {});
  }, [id]);

  const tabs = [
    { key: 'gates', label: t('gateGroup.tabGates') },
    { key: 'scope', label: t('gateGroup.scopeTab') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('gateGroup.title'), path: '/gate-groups' },
          { label: group?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'gates' && <GateGroupGatesTab groupId={id} />}
        {activeTab === 'scope' && <GateGroupScopeTab groupId={id} />}
      </TabContent>
    </PageContainer>
  );
}
